import React from 'react';
// import { Link } from 'react-router-dom';

import './style.scss';

const LinkCard = (props) => {
  const img = props.img;
  const name = props.name;
  // const link = props.link;
  const alt = props.alt;

  return (
    <div className="col-lg-4 col-md-6 col-6 equipment__container">
      {/* <Link to={{ link }} className="col-lg-4 col-md-6 col-6 equipment__container"> */}
      <div className="image__container">
        <img src={img} className="equipment__img" height="200" alt={alt} />
      </div>
      <span className="equipment__name">{name}</span>
      {/* </Link> */}
    </div>
  );
};

export default LinkCard;
